var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 72,
    viewBox: "0 0 40 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 46.383C1.5 36.1658 9.78273 27.8831 20 27.8831C30.2173 27.8831 38.5 36.1658 38.5 46.3831V66.4894C38.5 68.4224 36.933 69.9894 35 69.9894H5C3.067 69.9894 1.5 68.4224 1.5 66.4894V46.383Z",
    stroke: "white",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5745,
    cy: 14.4681,
    r: 12.9681,
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8188 44.7627C28.569 43.952 28.52 42.6867 27.7093 41.9364C26.8986 41.1862 25.6332 41.2352 24.883 42.0459L17.3743 50.1596L14.2723 46.6144C13.5449 45.7831 12.2814 45.6989 11.4501 46.4262C10.6188 47.1536 10.5346 48.4171 11.262 49.2484L15.7894 54.4226C15.8403 54.4807 15.8938 54.5352 15.9496 54.5861C15.959 54.5951 15.9685 54.6041 15.9781 54.6129C16.7888 55.3632 18.0541 55.3142 18.8044 54.5035L27.8188 44.7627Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/user-check.ed505b84bb1c43390834f7c039da33eb.svg";
export { ForwardRef as ReactComponent };